// 엑셀 업로드 — 양식/제약 설정
// 엑셀 양식 기준: Docs/디자인/엑셀양식.png
// 컬럼 헤더가 바뀌면 "이 파일만" 수정하면 파싱 로직 전체가 맞춰진다.

/** 엑셀 컬럼 헤더명 → 내부 필드 매핑 (엑셀양식.png 기준) */
export const EXCEL_HEADERS = {
  name: "상품명", // 필수, 최대 50자, 콤마 금지
  price: "가격", // 필수
  stock: "재고", // 필수
  option1: "옵션1", // 선택, 콤마 금지
  option2: "옵션2", // 선택, 콤마 금지
  productCode: "상품코드", // 선택
  description: "상품간략설명", // 선택, 최대 300자
  individualDelivery: "개별배송", // 선택, Y/N (빈 값은 N)
  individualDeliveryPrice: "개별배송비", // 선택, 0원 이상 (빈 값은 0)
  images: "이미지", // 선택, 콤마 구분 파일명(확장자 포함), 첫 번째=대표
} as const;

/** '이미지' 셀의 파일명 구분자 — 콤마 (예: image-1.jpg, image-2.png) */
export const IMAGE_NAME_DELIMITER = /,/;

/** 상품 1개당 최대 이미지 수 */
export const MAX_IMAGES_PER_PRODUCT = 10;

/** 입력 길이 제한 (양식 안내 기준) */
export const MAX_NAME_LEN = 50;
export const MAX_OPTION_LEN = 50;
export const MAX_DESC_LEN = 300;

/** 지원 이미지 확장자 (소문자, 점 제외) */
export const SUPPORTED_IMAGE_EXT = ["jpg", "jpeg", "png"];

/** 지원 엑셀 확장자 */
export const SUPPORTED_EXCEL_EXT = ["xlsx", "xls"];
